var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _path4, _linearGradient4, _path5, _linearGradient5, _path6, _linearGradient6, _path7, _linearGradient7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWireshark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: "64px",
    height: "64px",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    x1: 32,
    x2: 32,
    y1: 58,
    y2: 6,
    gradientTransform: "matrix(1 0 0 -1 0 64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#c822ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M53.5,17.5c-0.3,0.8-0.5,1.6-0.8,2.5c2.1,3.5,3.2,7.6,3.2,12c0,13.2-10.8,24-24,24c-7.9,0-15-3.9-19.4-9.8 c-0.2-0.2-0.3-0.4-0.5-0.6C9.6,41.7,8,37,8,32C8,18.8,18.8,8,32,8c5,0,9.6,1.5,13.5,4.1c0.7-0.3,1.4-0.7,2.1-1C43.2,8,37.8,6,32,6 C17.7,6,6,17.7,6,32s11.7,26,26,26s26-11.7,26-26C58,26.7,56.3,21.7,53.5,17.5z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066509642602792888560000007496454747092907423_",
    x1: 26.75,
    x2: 26.75,
    y1: 54.05,
    y2: 20.45,
    gradientTransform: "matrix(1 0 0 -1 0 64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#e6abff"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000066509642602792888560000007496454747092907423_)",
    d: "M13.5,43.1l-0.2,0.5 c-0.2-0.2-0.3-0.4-0.4-0.7C11,39.7,10,36,10,32c0-12.2,9.9-22,22-22c4.2,0,8.2,1.2,11.5,3.2C30.5,20.2,19.4,32.6,13.5,43.1z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168075333108725805940000012223439736307629456_",
    x1: 52.273,
    x2: 52.273,
    y1: 41.24,
    y2: 20.87,
    gradientTransform: "matrix(1 0 0 -1 0 64)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#e6abff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000168075333108725805940000012223439736307629456_)",
    d: "M54,32c0,4-1.1,7.7-2.9,11 c0,0.1-0.1,0.1-0.1,0.2c-1-8.3-0.2-15.2,1-20.4C53.3,25.6,54,28.7,54,32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M28.7,50.9L28.7,50.9L28.7,50.9z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008129566595572227730000017843493784833644471_",
    x1: 34.8,
    x2: 34.8,
    y1: 4.596,
    y2: 40.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c822ff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000008129566595572227730000017843493784833644471_)",
    fillRule: "evenodd",
    d: "M54.4,10.9c-1,1.5-7.8,13.6-5.3,33l-33.9,0.2C23.2,29.8,39,15,54.4,10.9z",
    clipRule: "evenodd"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178179438907572340090000015042638177559751591_",
    x1: 612.312,
    x2: 612.312,
    y1: -142.805,
    y2: -142.805,
    gradientTransform: "scale(1 -1) rotate(-39.547 513.076 723.054)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#c822ff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000178179438907572340090000015042638177559751591_)",
    d: "M38.3,7.8L38.3,7.8L38.3,7.8z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047046181590677548310000015942894902735596459_",
    x1: 630.954,
    x2: 630.954,
    y1: -182.658,
    y2: -182.658,
    gradientTransform: "scale(1 -1) rotate(-39.547 513.076 723.054)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a6dff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#c822ff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000047046181590677548310000015942894902735596459_)",
    d: "M27.3,50.4L27.3,50.4L27.3,50.4z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182503358186955513670000011614533556311125417_",
    x1: 31.95,
    x2: 31.95,
    y1: 36.638,
    y2: 53.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6dc7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#e6abff"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_00000182503358186955513670000011614533556311125417_)",
    d: "M51.1,43C47.3,49.6,40.2,54,32,54 s-15.4-4.5-19.2-11.1C13.2,43,13.6,43,14,43c2.6,0,4.8-0.9,6-3c1.2,2.1,3.4,3,6,3s4.8-0.9,6-3c1.2,2.1,3.4,3,6,3s4.8-0.9,6-3 c1.2,2.1,3.4,3,6,3C50.5,43,50.8,43,51.1,43z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireshark);
export default __webpack_public_path__ + "static/media/wireshark.f1995be4683cc39bbe7d6e4697703eb3.svg";
export { ForwardRef as ReactComponent };